
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicos",
      function () {
        return require("private-next-pages/servicos.tsx");
      }
    ]);
  